import SebraeDesignSystem, { SebraeStatus } from '@packages/design-system';
import { DOMAIN_STATUS_ALIASES, DOMAIN_STATUS_MAPS } from './utils/statusMap';
import { DOMAIN_SKELETON_PRESETS } from './utils/skeletonPresets';

/**
 * Registra o Design System com configuração de domínio do Portal
 * (statusMaps + skeletonPresets).
 *
 * @param {import('vue').App} app
 */
export function registerSebrae(app) {
    if (typeof SebraeStatus !== 'function' && typeof SebraeStatus !== 'object') {
        throw new Error(
            '[sebrae] SebraeStatus não encontrado em @packages/design-system. Rode: cd ../packages-design-system && npm run build',
        );
    }

    app.use(SebraeDesignSystem, {
        statusMaps: DOMAIN_STATUS_MAPS,
        statusAliases: DOMAIN_STATUS_ALIASES,
        skeletonPresets: DOMAIN_SKELETON_PRESETS,
    });
}
